<template>
    <div v-bind:style="containerStyle">
        <div v-bind:style="style" class="btn">
            <html-editor
                    ref="editor"

                    v-bind:toolbar-module="toolbarModule"
                    v-bind:toolbar-defaults="toolbarDefaults"
                    v-bind:theme="editorTheme"
                    v-bind:value="initialText"
                    @input="$emit('text-changed', $event)"
                    @blur="hasFocus = false"
                    @focus="hasFocus = true"
            ></html-editor>
        </div>
    </div>
</template>

<script>
    import rulesetGenerator  from '../../CustomStylingOptions/ruleset-generator';
    import dataStore from '../../Util/data-store';

    import fontSizes from '../../CustomStylingOptions/font-sizes';
    import fonts from '../../CustomStylingOptions/fonts';
    
    import {DEFAULT_SETTINGS_DATASTORE_KEY} from "../Template.vue";
    import HtmlEditor, {themes}  from '../../../../Components/Util/HtmlEditor/HtmlEditor.vue';
    
    const quillDefault = [];

    
    const defaultAlignment = 'center';
    
    export default {
        name: "template-block-button-content",
        components: {
            HtmlEditor
        },
        created(){
            const vm = this;
            
            vm.text = vm.metadata.text;
            
            //Quill stops working when we use our text as both input and the variable we write it's output to
            vm.initialText = vm.text;

            //Set our defaults + add a watch for any potential changes
            vm.setDefaults(dataStore.get(DEFAULT_SETTINGS_DATASTORE_KEY));
            vm.watchId = dataStore.startWatch(DEFAULT_SETTINGS_DATASTORE_KEY, defaults => vm.setDefaults(defaults));
        },
        destroyed(){
            dataStore.stopWatch(this.watchId);
        },
        methods: {
            setDefaults(defaults){
                const vm = this;

                vm.toolbarDefaults.font = defaults.font;
                vm.toolbarDefaults.size = defaults.fontSize;

                //After our editor has been fully initialized
                //A re-initializing is necessary for our new defaults to take place
                if(vm.$refs.editor){
                    vm.$refs.editor.reInitialize();
                }
            }
        },
        data: () => ({
            watchId: '',
            
            editorTheme: themes.bubble,

            toolbarModule: [
                [{ 'font': fonts }],
                [{ 'size': fontSizes }],
                [{ 'color': quillDefault }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'align': quillDefault }],
                ['clean']
            ],
            toolbarDefaults: {
                'align': defaultAlignment
            },
            hasFocus: false,
            text: '',
            initialText: ''
        }),
        computed: {
            containerStyle(){
                const ruleset = rulesetGenerator();
                ruleset.setRule('height', `${this.metadata.style.containerHeight}px`);
                
                return ruleset.toString();
            },
            style(){
                const ruleset = rulesetGenerator(this.metadata.style);
                ruleset.setFloatBasedContentPosition(
                    this.metadata.style.height, 
                    this.metadata.style.position
                );
                
                ruleset.setRule('display', 'block');
                ruleset.setRule('position', 'relative');
                
                return ruleset.toString();
            }
        },
        props: {
            metadata: {
                type: Object,
                required: true
            },
            templateDefaults: Object
        }
    };
</script>

<style scoped lang="scss" src="../../Style/template-column-button.scss">
</style>
